import React from 'react'
import { Col, Row } from 'react-bootstrap'
import NavTitle from '../../components/nav-title'
import SkyGroupLayout from '../../components/dashboard/SkyGroupCompany'
import TypeEmploys from '../../components/dashboard/TypeEmploys'
import StatusProbation from '../../components/dashboard/StatusProbation'
import TurnoverRate from '../../components/dashboard/TurnoverRate'
import TextNavTitle from '../../components/TextNavTitle'

function Index() {
  return (
    <Row>
      <NavTitle>
        <TextNavTitle>Dashboard </TextNavTitle>
      </NavTitle>
      <SkyGroupLayout />
      <Col md={3}>
        <TypeEmploys />
        <StatusProbation />
      </Col>
      <Col md={9} className="mb-3">
        <TurnoverRate />
      </Col>
    </Row>
  )
}

export default Index
